import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../lib/cn';

/**
 * Унифицированный переключатель (Toggle/Switch)
 * Соответствует единому стилю элементов управления
 */
export const Toggle = ({
  checked,
  onChange,
  disabled = false,
  size = 'md',
  label = '',
  id = '',
  className = '',
  onClick,
  ...props
}) => {
  const toggleId = id || `toggle-${Math.random().toString(36).substr(2, 9)}`;

  const handleChange = (e) => {
    if (disabled) return;
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  // Размеры привязаны к сетке 4/8px
  const sizes = {
    sm: {
      track: 'w-8 h-4.5',
      thumb: 'w-3.5 h-3.5',
      translate: 'translate-x-3.5',
    },
    md: {
      track: 'w-12 h-6',
      thumb: 'w-5 h-5',
      translate: 'translate-x-6',
    },
    lg: {
      track: 'w-14 h-8',
      thumb: 'w-6 h-6',
      translate: 'translate-x-6',
    },
  };

  const sizeClasses = sizes[size] || sizes.md;

  return (
    <div className={cn('flex items-center', className)} onClick={onClick}>
      <label htmlFor={toggleId} className="flex items-center cursor-pointer relative">
        <input
          type="checkbox"
          id={toggleId}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          className="sr-only"
          {...props}
        />

        {/* Track */}
        <div
          className={cn(
            sizeClasses.track,
            'rounded-full transition-all duration-200 ease-in-out flex items-center px-0.5 border border-[var(--color-border)]',
            checked
              ? 'bg-[var(--color-accent-primary)]'
              : 'bg-[var(--color-bg-tertiary)]',
            disabled && 'opacity-50 cursor-not-allowed'
          )}
        >
          {/* Thumb */}
          <div
            className={cn(
              sizeClasses.thumb,
              'rounded-full bg-white shadow-sm transform transition-transform duration-200 ease-in-out',
              checked ? sizeClasses.translate : 'translate-x-0'
            )}
          />
        </div>
      </label>

      {label && (
        <span
          className={cn(
            'ml-3 text-sm font-medium text-[var(--color-text-primary)]',
            disabled && 'opacity-50'
          )}
        >
          {label}
        </span>
      )}
    </div>
  );
};

Toggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  label: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
};

export default Toggle;